module.exports = __webpack_public_path__ + "img/marialuisa_.ef80fb1c.jpg";